import React, { Component } from 'react';
import theme from '../theme';
import { clearConsent } from '../utils/cookieConsent';

export class Footer extends Component {
  static displayName = Footer.name;

    handleCookieSettings = (e) => {
        e.preventDefault();
        clearConsent();
        window.location.reload();
    };

    render() {
        const linkStyle = {
            display: 'block',
            textDecoration: 'none',
            color: 'rgba(255,255,255,0.85)',
            fontFamily: "'Inter', sans-serif",
            fontSize: '14px',
            marginBottom: '8px',
            transition: 'color 0.2s ease',
        };

        const headingStyle = {
            fontFamily: "'Inter', sans-serif",
            fontSize: '10px',
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: 'rgba(255,255,255,0.5)',
            marginBottom: '14px',
        };

        return (
            <footer style={{ padding: '48px 32px 28px', backgroundColor: theme.colors.footer, color: theme.colors.textfooter }}>
                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                    {/* Three columns */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px', marginBottom: '36px' }}>
                        {/* Brand */}
                        <div style={{ flex: '1 1 180px', minWidth: '160px' }}>
                            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '26px', fontWeight: 400, letterSpacing: '0.06em', marginBottom: '10px' }}>
                                ho.li design
                            </div>
                            <p style={{ fontSize: '13px', fontFamily: "'Inter', sans-serif", color: 'rgba(255,255,255,0.72)', lineHeight: 1.6, fontWeight: 300, margin: 0 }}>
                                Stylische Poufs –<br />für drinnen und draußen.
                            </p>
                        </div>
                        {/* Navigation */}
                        <div style={{ flex: '1 1 120px', minWidth: '120px' }}>
                            <div style={headingStyle}>Entdecken</div>
                            <a href="/" style={linkStyle}>Home</a>
                            <a href="/shop" style={linkStyle}>Shop</a>
                            <a href="/about" style={linkStyle}>Über uns</a>
                            <a href="/contact" style={linkStyle}>Kontakt</a>
                            <a href="/reviews" style={linkStyle}>Bewertungen</a>
                        </div>
                        {/* Legal */}
                        <div style={{ flex: '1 1 120px', minWidth: '120px' }}>
                            <div style={headingStyle}>Rechtliches</div>
                            <a href="/impressum" style={linkStyle}>Impressum</a>
                            <a href="/privacy" style={linkStyle}>Datenschutz</a>
                            <a href="/agb" style={linkStyle}>AGB</a>
                            <a href="#" onClick={this.handleCookieSettings} style={linkStyle}>Cookie-Einstellungen</a>
                        </div>
                    </div>
                    {/* Bottom bar */}
                    <div style={{ borderTop: '1px solid rgba(255,255,255,0.18)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                        <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'rgba(255,255,255,0.55)' }}>
                            &copy; 2026 ho.li design GmbH – Alle Rechte vorbehalten
                        </span>
                        <span style={{ fontFamily: "'Inter', sans-serif", fontSize: '12px', color: 'rgba(255,255,255,0.55)' }}>
                            info@holidesign.de
                        </span>
                    </div>
                </div>
            </footer>
        );
    }
}

